document.addEventListener("DOMContentLoaded", function () {
  const accountIcon = document.getElementById("account_icon");
  const accountContainer = document.getElementById("account_container");
  const accountDropdownLoggedIn = document.getElementById("account_dropdown_logged_in");
  const accountDropdownLoggedOut = document.getElementById("account_dropdown_logged_out");
  
  // Use whichever dropdown exists based on login state
  const dropdownMenu = accountDropdownLoggedIn || accountDropdownLoggedOut;

  if (accountContainer && dropdownMenu) {
    let isDropdownOpen = false;

    // Toggle dropdown when clicking the account icon or any of its children
    accountContainer.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      isDropdownOpen = !isDropdownOpen;
      dropdownMenu.classList.toggle("hidden");
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function (event) {
      // Ignore clicks from predictive search
      if (event.target.closest('predictive-search')) {
        return;
      }

      // Check if the click is outside the account container
      if (!accountContainer.contains(event.target)) {
        isDropdownOpen = false;
        dropdownMenu.classList.add("hidden");
      }
    });

    // Prevent dropdown from closing when clicking inside it
    dropdownMenu.addEventListener("click", function (event) {
      event.stopPropagation();
    });
  }
});


document.addEventListener("DOMContentLoaded", function() {
  let isPopupAllowed = false; // Initially, the popup is not allowed to be shown

  // Function to hide the popup
  function hidePopup() {
    if (!isPopupAllowed) {
      let popup = document.querySelector(".ZipCodeRestrict.modal_popup");
      if (popup) {
        popup.style.display = "none";
      }
    }
  }

  // Function to show the popup
  function showPopup() {
    isPopupAllowed = true; // Allow the popup to remain open
    let popup = document.querySelector(".ZipCodeRestrict.modal_popup");
    if (popup) {
      popup.style.display = "block"; // Show the popup
    }
  }

  // Function to close the popup
  function closePopup() {
    isPopupAllowed = false; // Disallow the popup
    let popup = document.querySelector(".ZipCodeRestrict.modal_popup");
    if (popup) {
      popup.style.display = "none"; // Hide the popup
    }
  }

  // Initial attempt to hide the popup
  hidePopup();

  // Set up a MutationObserver to monitor the DOM for changes
  const observer = new MutationObserver(hidePopup);
  observer.observe(document.body, { childList: true, subtree: true });

  // Event listener to show the popup when "zipcode_header_section" is clicked
  document.querySelector(".zipcode_header_section").addEventListener("click", showPopup);

  // Event listener to close the popup when "aj-remove close-popup" is clicked
  document.querySelector(".aj-remove.close-popup").addEventListener("click", closePopup);
});


document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') { // Check if the Enter key is pressed
            const button = document.querySelector('.zipcode_submit');
            if (button) {
                button.click(); // Trigger the button click
            }
        }
    });
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  if (summary.closest('header-drawer, menu-drawer')) return;

  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const focusableElements = Array.from(
    container.querySelectorAll(
      '[tabindex]:not([tabindex="-1"]), a[href], button:not([disabled]):not([data-ignore-focus-trap]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled])'
    )
  );

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  function handleFocusTrap(event) {
    if (event.key !== 'Tab') return;

    if (event.shiftKey && document.activeElement === firstFocusable) {
      lastFocusable.focus();
      event.preventDefault();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      firstFocusable.focus();
      event.preventDefault();
    }
  }

  container.addEventListener('keydown', handleFocusTrap);
  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    // Create debounced version of handleCartUpdate to prevent rapid API calls
    this.debouncedHandleCartUpdate = debounce(this.handleCartUpdate.bind(this), 500);
    // Listen for cart updates from cart drawer to sync main page quantity inputs
    this.cartUpdateListener = this.handleCartUpdateFromDrawer.bind(this);
    document.addEventListener('cart:refresh', this.cartUpdateListener);
  }

  connectedCallback() {
    // Initialize the input value from the data-cart-quantity attribute
    if (this.input && this.input.dataset.cartQuantity) {
      const cartQuantity = parseInt(this.input.dataset.cartQuantity) || 0;
      this.input.value = cartQuantity;
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateListener) {
      document.removeEventListener('cart:refresh', this.cartUpdateListener);
    }
  }

  handleCartUpdateFromDrawer(event) {
    const cartData = event.detail;
    if (!cartData || !cartData.items) return;

    // Find the corresponding item in the cart data
    const variantId = this.getAttribute('data-index');
    const cartItem = cartData.items.find(item => item.variant_id.toString() === variantId);
    
    if (cartItem) {
      // Update the input value and dataset to match cart state
      this.input.value = cartItem.quantity;
      this.input.dataset.cartQuantity = cartItem.quantity;
    } else {
      // Item not in cart, reset to 0
      this.input.value = 0;
      this.input.dataset.cartQuantity = 0;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
  
    // Increment or decrement the value
    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
  
    // Log the values to ensure the input is being updated
    console.log('Previous Value:', previousValue, 'New Value:', this.input.value);
  
    if (previousValue !== this.input.value) {
      // Dispatch the change event first
      this.input.dispatchEvent(this.changeEvent);
      
      // Handle cart update based on UI state
      this.debouncedHandleCartUpdate();
    }
  }

  async handleCartUpdate() {
    const variantId = this.getAttribute('data-index');
    const newQuantity = parseInt(this.input.value) || 0;
    // No need to check currentCartQuantity or isCurrentlyInCart anymore

    console.log('=== handleCartUpdate called ===');
    console.log('Cart update:', {
      variantId,
      newQuantity
    });

    try {
      if (newQuantity === 0) {
        // Always try to remove from cart when quantity is 0
        console.log('Removing from cart (quantity is 0)');
        await this.updateCart(variantId, 0);
      } else if (newQuantity > 0) {
        // Always use updateCart for add or update
        console.log('Updating cart (add or update)');
        await this.updateCart(variantId, newQuantity);
      } else {
        // No action needed (both 0)
        console.log('No action needed');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  async updateCart(variantId, quantity) {
    console.log('=== updateCart called ===');
    console.log('Updating cart with variantId:', variantId, 'quantity:', quantity);
    
    // Show loading animation on header
    this.showCartLoading(variantId);
    
    // Show loading on all elements that will be updated BEFORE the API call
    console.log('About to call showLoadingOnAllElementsBeforeUpdate');
    console.log('Function exists:', typeof this.showLoadingOnAllElementsBeforeUpdate);
    try {
      this.showLoadingOnAllElementsBeforeUpdate(variantId, quantity);
      console.log('Successfully called showLoadingOnAllElementsBeforeUpdate');
    } catch (error) {
      console.error('Error in showLoadingOnAllElementsBeforeUpdate:', error);
    }
    console.log('Finished calling showLoadingOnAllElementsBeforeUpdate');
    
    const updates = {
      [variantId]: quantity
    };
    
    console.log('Sending cart update request with updates:', updates);
    
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('Cart update failed:', errorData);
      // Hide loading animations on error
      this.hideLoadingOnAllElementsAfterUpdate();
      throw new Error(errorData.description || errorData.message || 'Update failed');
    }
    
    const cartData = await response.json();
    console.log('Cart update successful, received cartData:', cartData);
    
    // Update the dataset immediately so subsequent operations use correct quantity
    this.input.dataset.cartQuantity = quantity;
    
    this.updateUI(cartData);
    
    // Hide loading animation
    this.hideCartLoading(variantId);
    
    // Hide loading animations after a delay to show the update
    setTimeout(() => {
      this.hideLoadingOnAllElementsAfterUpdate();
    }, 500);
  }

  showCartLoading(variantId) {
    console.log('showCartLoading called');
    const cartMoneyContainer = document.getElementById('header-price-container');
    console.log('cartMoneyContainer found:', !!cartMoneyContainer);
    if (cartMoneyContainer) {
      // Try a built-in animation first
      cartMoneyContainer.classList.add('animated-background');
    }
  }

  hideCartLoading(variantId) {
    console.log('hideCartLoading called');
    const cartMoneyContainer = document.getElementById('header-price-container');
    if (cartMoneyContainer) {
      // Try a built-in animation first
      cartMoneyContainer.classList.remove('animated-background');
    }
  }

  showElementLoading(element) {
    if (element) {
      element.classList.add('animated-background');
    }
  }

  hideElementLoading(element) {
    if (element) {
      element.classList.remove('animated-background');
    }
  }

  showLoadingOnAllElements(cartData) {
    // Show loading on cart totals
    const cartTotalElement = document.querySelector('.cart-total');
    const mainCartTotalElement = document.querySelector('.totals__total-value');
    const subtotalElement = document.querySelector('.cart-subtotal');
    const taxesElement = document.querySelector('.cart-taxes');
    const shippingElement = document.querySelector('.cart-shipping');
    
    if (cartTotalElement) this.showElementLoading(cartTotalElement);
    if (mainCartTotalElement) this.showElementLoading(mainCartTotalElement);
    if (subtotalElement) this.showElementLoading(subtotalElement);
    if (taxesElement) this.showElementLoading(taxesElement);
    if (shippingElement) this.showElementLoading(shippingElement);
    
    // Show loading on line item prices
    cartData.items.forEach(item => {
      const allElements = document.querySelectorAll(`#line-item-price-${item.id}`);
      allElements.forEach(element => {
        this.showElementLoading(element);
      });
    });
    
    // Show loading on quantity inputs
    cartData.items.forEach(item => {
      const quantityInput = document.querySelector(`#Quantity-${item.index + 1}`);
      if (quantityInput) {
        this.showElementLoading(quantityInput);
      }
    });
  }

  hideLoadingOnAllElements(cartData) {
    // Hide loading on cart totals
    const cartTotalElement = document.querySelector('.cart-total');
    const mainCartTotalElement = document.querySelector('.totals__total-value');
    const subtotalElement = document.querySelector('.cart-subtotal');
    const taxesElement = document.querySelector('.cart-taxes');
    const shippingElement = document.querySelector('.cart-shipping');
    
    if (cartTotalElement) this.hideElementLoading(cartTotalElement);
    if (mainCartTotalElement) this.hideElementLoading(mainCartTotalElement);
    if (subtotalElement) this.hideElementLoading(subtotalElement);
    if (taxesElement) this.hideElementLoading(taxesElement);
    if (shippingElement) this.hideElementLoading(shippingElement);
    
    // Hide loading on line item prices
    cartData.items.forEach(item => {
      const allElements = document.querySelectorAll(`#line-item-price-${item.id}`);
      allElements.forEach(element => {
        this.hideElementLoading(element);
      });
    });
    
    // Hide loading on quantity inputs
    cartData.items.forEach(item => {
      const quantityInput = document.querySelector(`#Quantity-${item.index + 1}`);
      if (quantityInput) {
        this.hideElementLoading(quantityInput);
      }
    });
  }

  showLoadingOnAllElementsBeforeUpdate(variantId, quantity) {
    console.log('=== showLoadingOnAllElementsBeforeUpdate called ===');
    console.log('Showing loading animations BEFORE update for variantId:', variantId);
    
    // Store elements that get loading animation for later cleanup
    this.loadingElements = [];
    
    // Show loading on cart totals
    const cartTotalElement = document.querySelector('.cart-total');
    const mainCartTotalElement = document.querySelector('.totals__total-value');
    const subtotalElement = document.querySelector('.cart-subtotal');
    const taxesElement = document.querySelector('.cart-taxes');
    const shippingElement = document.querySelector('.cart-shipping');
    
    [cartTotalElement, mainCartTotalElement, subtotalElement, taxesElement, shippingElement].forEach(element => {
      if (element) {
        this.showElementLoading(element);
        this.loadingElements.push(element);
      }
    });
    
    // Find the specific item being updated by variantId
    // Since cart data isn't available before the API call, we need to find the elements differently
    
    // Method 1: Find line item price elements that contain this variantId in their data attributes or context
    const allLineItemPrices = document.querySelectorAll('[id^="line-item-price-"]');
    console.log('All line item prices found:', allLineItemPrices.length);
    
    // Find the specific line item price for this variant by looking at the quantity input context
    const currentQuantityInput = this.input;
    const currentRow = currentQuantityInput?.closest('tr');
    const currentRowId = currentRow?.getAttribute('id');
    console.log('Current row ID:', currentRowId);
    
    // Find the line item price within the same row
    const lineItemPriceInRow = currentRow?.querySelector('[id^="line-item-price-"]');
    console.log('Line item price in current row:', lineItemPriceInRow);
    
    if (lineItemPriceInRow) {
      // Show loading on the line item price in the current row
      console.log('Adding loading to line item price in current row:', lineItemPriceInRow);
      this.showElementLoading(lineItemPriceInRow);
      this.loadingElements.push(lineItemPriceInRow);
      
      // Also find and show loading on any other elements with the same ID (for cart drawer)
      const sameIdElements = document.querySelectorAll(`#${lineItemPriceInRow.id}`);
      console.log(`Found ${sameIdElements.length} elements with same ID: ${lineItemPriceInRow.id}`);
      sameIdElements.forEach(element => {
        if (element !== lineItemPriceInRow) {
          console.log('Adding loading to duplicate element:', element);
          this.showElementLoading(element);
          this.loadingElements.push(element);
        }
      });
      
      // Also show loading on cart drawer line item price if it exists
      // Extract the item index from the row ID (e.g., "CartItem-1" -> "1")
      const itemIndex = currentRowId?.replace('CartItem-', '') || currentRowId?.replace('CartDrawer-Item-', '');
      if (itemIndex) {
        const cartDrawerLineItemPrice = document.querySelector(`#CartDrawer-Item-${itemIndex} .price.price--end`);
        console.log('Cart drawer line item price element:', cartDrawerLineItemPrice);
        if (cartDrawerLineItemPrice) {
          console.log('Showing loading on cart drawer line item price');
          this.showElementLoading(cartDrawerLineItemPrice);
          this.loadingElements.push(cartDrawerLineItemPrice);
        }
      }
    } else {
      // Fallback: show loading on all line item prices if we can't find the specific one
      console.log('Could not find specific line item price, showing loading on all line item prices');
      allLineItemPrices.forEach(element => {
        console.log('Adding loading to all line item price element:', element);
        this.showElementLoading(element);
        this.loadingElements.push(element);
      });
    }
    
    // Show loading on the specific quantity input being changed
    if (this.input) {
      this.showElementLoading(this.input);
      this.loadingElements.push(this.input);
    }
  }

  hideLoadingOnAllElementsAfterUpdate() {
    console.log('Hiding loading animations AFTER update');
    
    // Hide loading on all elements that were shown loading
    if (this.loadingElements && this.loadingElements.length > 0) {
      this.loadingElements.forEach(element => {
        this.hideElementLoading(element);
      });
      this.loadingElements = [];
    }
  }

  updateUI(cartData) {
    console.log('updateUI called with cartData:', cartData);
    
    // Update cart totals
    this.updateCartTotals(cartData);
    // Update individual item quantities
    this.updateCartUI(cartData);
    // Update line item prices
    this.updateLineItemPrices(cartData);
    // Update global cart UI (icon bubble, totals, etc.)
    this.refreshCartSections(cartData);
    // Dispatch a custom event for other scripts
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cartData }));
  }

  async refreshCartSections(cartData) {
    // Update cart count bubble and cart total directly
    try {
      console.log('refreshCartSections called with cartData:', cartData);
      console.log('cartData.total_price:', cartData.total_price);
      console.log('cartData.total_price type:', typeof cartData.total_price);
      
      // Update cart total in header
      const cartTotal = document.getElementById('cart-total');
      if (cartTotal) {
        const newTotal = `$${(cartData.total_price / 100).toFixed(2)}`;
        console.log('Setting cart total to:', newTotal);
        cartTotal.textContent = newTotal;
      }
      
      // Update cart money container if it exists
      const cartMoneyContainer = document.getElementById('cart-money-container');
      if (cartMoneyContainer) {
        const priceElement = cartMoneyContainer.querySelector('.header__price');
        if (priceElement) {
          priceElement.textContent = `$${(cartData.total_price / 100).toFixed(2)}`;
        }
      }
      
      // Handle cart count bubble - update existing or create new one
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        let cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
        
        if (cartData.item_count === 0) { // Remove cart count bubble if cart is empty
          if (cartCountBubble) {
            cartCountBubble.remove();
          }
        } else {
          // Create or update cart count bubble
          if (!cartCountBubble) {
            cartCountBubble = document.createElement('div');
            cartCountBubble.className = 'cart-count-bubble';
            cartIconBubble.appendChild(cartCountBubble);
          }
          
          // Update the count
          const countSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
          if (countSpan) {
            countSpan.textContent = cartData.item_count;
          } else {
            cartCountBubble.innerHTML = `
              <span aria-hidden="true">${cartData.item_count}</span>
              <span class="visually-hidden">${cartData.item_count} items</span>
            `;
          }
        }
      }

      // --- Update cart drawer ---
      const cartDrawer = document.getElementById('CartDrawer');
      if (cartDrawer) {
        // Fetch the cart-drawer section HTML
        const url = `/?section_id=cart-drawer`;
        const response = await fetch(url);
        if (response.ok) {
          const html = await response.text();
          // Parse and extract the new CartDrawer HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const newDrawer = tempDiv.querySelector('#CartDrawer');
          if (newDrawer) {
            cartDrawer.innerHTML = newDrawer.innerHTML;
          }
        }
      }

      // --- Update header section (cart icon bubble, totals, etc.) ---
      // (No longer replacing the entire header section to avoid appearance changes)
      // The cart total and cart count bubble are already updated above.
    } catch (e) {
      console.error('Error refreshing cart sections:', e);
    }
  }
  
  updateLineItemPrices(cartData) {
    console.log('updateLineItemPrices called with cartData:', cartData);
    cartData.items.forEach(item => {
      const allElements = document.querySelectorAll(`#line-item-price-${item.id}`);
      console.log(`Found ${allElements.length} elements with id line-item-price-${item.id}`);
      
      const lineItemPriceElement = document.querySelector(`#line-item-price-${item.id}`);
      console.log(`Looking for line-item-price-${item.id}:`, lineItemPriceElement);
      if (lineItemPriceElement) {
        const currentText = lineItemPriceElement.textContent;
        const itemTotalPrice = (item.line_price / 100).toFixed(2);
        const newText = `$${itemTotalPrice}`;
        console.log(`Current text: "${currentText}", New text: "${newText}"`);
        console.log(`Updating line item price for item ${item.id} to: $${itemTotalPrice}`);
        lineItemPriceElement.textContent = newText;
        console.log(`After update, text content is: "${lineItemPriceElement.textContent}"`);
        
        // Also try updating all elements with this ID if there are multiple
        if (allElements.length > 1) {
          console.log(`Updating all ${allElements.length} elements with this ID`);
          allElements.forEach((element, index) => {
            console.log(`Updating element ${index + 1}:`, element);
            element.textContent = newText;
          });
        }
      } else {
        console.log(`Line item price element not found for item ${item.id}`);
      }
    });
  }
  
  updateCartUI(cartData) {
    cartData.items.forEach(item => {
      const quantityInput = document.querySelector(`#Quantity-${item.index + 1}`);
      if (quantityInput) {
        quantityInput.value = item.quantity;
        quantityInput.dataset.cartQuantity = item.quantity;
      }
    });
  }
  
  updateCartTotals(cartData) {
    console.log('updateCartTotals called with cartData:', cartData);
    const cartTotalElement = document.querySelector('.cart-total');
    console.log('Header cart total element:', cartTotalElement);
    if (cartTotalElement) {
      cartTotalElement.textContent = `$${(cartData.total_price / 100).toFixed(2)}`;
    }
  
    // Update main cart total
    const mainCartTotalElement = document.querySelector('.totals__total-value');
    console.log('Main cart total element:', mainCartTotalElement);
    if (mainCartTotalElement) {
      const newTotal = `$${(cartData.total_price / 100).toFixed(2)}`;
      console.log(`Updating main cart total to: ${newTotal}`);
      mainCartTotalElement.textContent = newTotal;
    } else {
      console.log('Main cart total element not found');
    }
  
    const subtotalElement = document.querySelector('.cart-subtotal');
    if (subtotalElement) {
      subtotalElement.textContent = `$${(cartData.subtotal_price / 100).toFixed(2)}`;
    }
  
    const taxesElement = document.querySelector('.cart-taxes');
    if (taxesElement && cartData.tax_lines) {
      const totalTaxes = cartData.tax_lines.reduce((acc, taxLine) => acc + taxLine.price, 0);
      taxesElement.textContent = `$${(totalTaxes / 100).toFixed(2)}`;
    }
  
    const shippingElement = document.querySelector('.cart-shipping');
    if (shippingElement && cartData.shipping_price) {
      shippingElement.textContent = `$${(cartData.shipping_price / 100).toFixed(2)}`;
    }
  }
}

class QuantityInput2 extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
  
    // Increment or decrement the value
    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
  
    // Log the values to ensure the input is being updated
    console.log('QuantityInput2 Previous Value:', previousValue, 'New Value:', this.input.value);
  
    if (previousValue !== this.input.value) {
      // Only dispatch the change event - let quick-add-bulk handle the cart update
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define('quantity-input', QuantityInput);
customElements.define('quantity-input2', QuantityInput2);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );

    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    this.querySelectorAll('a.menu-drawer__menu-item').forEach((link) => {
      if (!link.closest('details')) {
        link.addEventListener('click', () => {
          if (this.mainDetailsToggle.hasAttribute('open')) {
            this.closeMenuDrawer(new Event('click'), link);
          }
        });
      }
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onFocusOut(event) {
    setTimeout(() => {
      const activeElement = document.activeElement;

      if (event.relatedTarget && this.contains(event.relatedTarget)) return;
      if (activeElement && this.contains(activeElement)) return;
      if (activeElement?.classList.contains('add-to-cart-button')) return;

      // Mobile taps often leave focus on body without a relatedTarget
      if (!event.relatedTarget && (activeElement === document.body || !activeElement)) return;

      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.closeMenuDrawer(null, this.mainDetailsToggle.querySelector('summary'));
      }
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (detailsElement) this.closeSubmenu(detailsElement);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    const summaryElement = this.mainDetailsToggle.querySelector('summary');
    if (summaryElement) summaryElement.setAttribute('aria-expanded', false);
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');

    const summary = detailsElement.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);

    removeTrapFocus(summary);
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    const submenu = detailsElement.querySelector('.menu-drawer__submenu');

    if (submenu) {
      submenu.style.transform = 'translateX(100%)';
      submenu.style.visibility = 'hidden';
    }

    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');

        if (submenu) {
          submenu.style.transform = '';
          submenu.style.visibility = '';
        }

        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    super.closeMenuDrawer(event, elementToFocus);
    if (this.header) this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton || !this.prevButton) return; // Ensure both buttons exist

      // Attach event listeners
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

      this.initPages();
      const resizeObserver = new ResizeObserver(() => this.initPages());
      resizeObserver.observe(this.slider);
      this.slider.addEventListener('scroll', this.update.bind(this));
    }

    initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    
    // Reset scroll position to the start
    this.slider.scrollTo({ left: 0, behavior: 'auto' });

    this.update();
}


    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }

    update() {
      if (!this.slider || !this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.currentPage !== previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        );
      }

      if (this.enableSliderLooping) return;

      this.prevButton.toggleAttribute('disabled', this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0);
      this.nextButton.toggleAttribute('disabled', this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]));
    }

    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
      event.preventDefault();
      console.log("Button clicked:", event.currentTarget.name); // Debug log
      const step = parseInt(event.currentTarget.dataset.step, 10) || 1; // Use a number
      this.slideScrollPosition =
          event.currentTarget.name === 'next'
              ? this.slider.scrollLeft + step * this.sliderItemOffset
              : this.slider.scrollLeft - step * this.sliderItemOffset;

      this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position) {
    console.log("Current scroll position:", this.slider.scrollLeft); // Log current position
    console.log("Setting slide position to:", position); // Debug log
    this.slider.scrollTo({
        left: position,
        behavior: 'smooth', // Optional: for smooth scrolling
    });
    console.log("New scroll position after setting:", this.slider.scrollLeft); // Log new position
}

  }

  customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
  super();
  this.sliderControlWrapper = this.querySelector('.slider-buttons');
  
  // Define the button references
  this.prevButton = this.sliderControlWrapper.querySelector('.slider-button--prev');
  this.nextButton = this.sliderControlWrapper.querySelector('.slider-button--next');

  console.log('Prev Button:', this.prevButton); // This should log the button element
  console.log('Next Button:', this.nextButton); // This should log the button element


  this.enableSliderLooping = true;

  if (!this.sliderControlWrapper) return;

  // Initialize other properties
  this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
  if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

  // Announcement bar logic
  this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
  this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

  // Event listeners for slider control links
  this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
  this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));

  // Add event listeners for prev and next buttons
  this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
  this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

  // Event listener for scroll event
  this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
  this.setSlideVisibility();

  // Autoplay logic
  if (this.announcementBarSlider) {
    this.announcementBarArrowButtonWasClicked = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.reducedMotion.addEventListener('change', () => {
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    });

    [this.prevButton, this.nextButton].forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          this.announcementBarArrowButtonWasClicked = true;
        },
        { once: true }
      );
    });
  }

  if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }


  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;
  
    const isNextButton = event.currentTarget.name === 'next';
    const isPrevButton = event.currentTarget.name === 'previous';
  
    if (isNextButton) {
      if (this.currentPage < this.sliderItemsToShow.length) {
        this.currentPage++;
        this.setSlidePosition(this.slider.scrollLeft + this.sliderItemOffset); // Adjust based on your logic
      }
    } else if (isPrevButton) {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.setSlidePosition(this.slider.scrollLeft - this.sliderItemOffset); // Adjust based on your logic
      }
    }
  
    this.update(); // Ensure the UI is updated
    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

// Function to handle checkout button click
function setupCheckoutButton() {
  // Try multiple selectors to find checkout button
  const checkoutButton = document.getElementById('checkout') || 
                         document.querySelector('[name="checkout"]') ||
                         document.querySelector('button[name="checkout"]') ||
                         document.querySelector('#checkout');

  console.log('Global.js - Checkout button found:', !!checkoutButton, checkoutButton);

  if (checkoutButton) {
    // Remove any existing listeners by cloning the button
    // IMPORTANT: Remove disabled class before cloning to prevent it from being copied
    const hadDisabledClass = checkoutButton.classList.contains('disabled');
    if (hadDisabledClass) {
      checkoutButton.classList.remove('disabled');
    }
    
    const newButton = checkoutButton.cloneNode(true);
    checkoutButton.parentNode.replaceChild(newButton, checkoutButton);
    
    // Ensure the cloned button doesn't have disabled class if it shouldn't
    // Check if button should be enabled (not disabled attribute, not disabled class from CSS)
    if (!newButton.disabled && !newButton.hasAttribute('disabled')) {
      newButton.classList.remove('disabled');
    }
    
    // Update delivery-checkout.js reference if it exists
    if (window.deliveryCheckout && window.deliveryCheckout.checkoutButton) {
      window.deliveryCheckout.checkoutButton = newButton;
      console.log('Global.js - Updated delivery-checkout.js button reference');
    }
    
    // Add click handler with capture phase to run first
    newButton.addEventListener('click', async function (event) {
      const isDisabled = this.disabled || this.hasAttribute('disabled');
      
      console.log('Global.js - Checkout button clicked!', {
        disabled: this.disabled,
        hasDisabledAttribute: this.hasAttribute('disabled'),
        isDisabled: isDisabled,
        target: event.target,
        currentTarget: event.currentTarget
      });
      
      // Don't proceed if button is disabled
      if (isDisabled) {
        console.log('Global.js - Checkout button is disabled, ignoring click');
        return;
      }
      
      // Don't proceed if already loading
      if (this.classList.contains('is-loading')) {
        console.log('Global.js - Checkout button is already processing');
        return;
      }
      
      event.preventDefault(); // Prevent default checkout for a moment
      event.stopPropagation(); // Stop event from bubbling
      event.stopImmediatePropagation(); // Stop other handlers

      // Show loading spinner immediately
      this.classList.add('is-loading');
      this.disabled = true;
      console.log('Global.js - Showing loading spinner');

      try {
        // First, fetch current cart data to check for substitution properties
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Failed to fetch cart data');
        
        const cartData = await cartResponse.json();
        console.log('Current cart data:', cartData);

        // Check if any items need the "Substitutions: allowed" property added
        const itemsToUpdate = [];
        
        cartData.items.forEach(item => {
          const substitutionsProperty = item.properties?.Substitutions;
          console.log(`Item ${item.id}: Substitutions property = "${substitutionsProperty}"`);
          
          // If the item doesn't have "Substitutions: not_allowed", add "Substitutions: allowed"
          if (substitutionsProperty !== 'not_allowed') {
            itemsToUpdate.push({
              id: item.key,
              quantity: item.quantity,
              properties: {
                ...item.properties,
                Substitutions: 'allowed'
              }
            });
            console.log(`Will update item ${item.id} to add Substitutions: allowed`);
          }
        });

        // Update items that need the substitution property
        if (itemsToUpdate.length > 0) {
          console.log('Updating items with substitution properties:', itemsToUpdate);
          
          for (const item of itemsToUpdate) {
            const updateResponse = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(item)
            });
            
            if (!updateResponse.ok) {
              const errorData = await updateResponse.json();
              console.error('Failed to update item:', errorData);
              throw new Error(`Failed to update item ${item.id}`);
            }
            
            console.log(`✅ Successfully updated item ${item.id} with Substitutions: allowed`);
          }
        } else {
          console.log('No items need substitution property updates');
        }

        // Note: Cart note is handled by delivery-checkout.js via /cart/update.js
        // No need to update it here as it's already in the form

        // CRITICAL: Ensure delivery data is saved to cart before navigating
        if (window.deliveryCheckout && typeof window.deliveryCheckout.updateCartAttributes === 'function') {
          console.log('Global.js - Updating cart attributes with delivery data before checkout');
          try {
            await window.deliveryCheckout.updateCartAttributes();
            console.log('Global.js - Cart attributes updated successfully');
          } catch (error) {
            console.error('Global.js - Error updating cart attributes:', error);
            // Continue to checkout even if there's an error
          }
        } else {
          console.warn('Global.js - deliveryCheckout.updateCartAttributes not available, cart attributes may not be saved');
        }

      } catch (error) {
        console.error('❌ Error during checkout preparation:', error);
        // Continue to checkout even if there's an error
        // Hide loading spinner on error (navigation will happen anyway)
        this.classList.remove('is-loading');
        this.disabled = false;
      }

      // Navigate directly to checkout
      // Note: We don't submit the form because its action is /cart (for updates)
      // Instead, we navigate directly to /checkout which will use the cart attributes
      // that were already set via the Cart API
      console.log('Global.js - Navigating to checkout');
      // Keep spinner visible during navigation
      window.location.href = '/checkout';
    }, true); // Use capture phase to run before other handlers
    
    console.log('Global.js - Checkout button handler attached');
  } else {
    console.warn('Global.js - Checkout button not found');
  }
}

// Setup on DOM ready
document.addEventListener('DOMContentLoaded', setupCheckoutButton);

// Also setup after a delay in case button is added dynamically
setTimeout(setupCheckoutButton, 1000);

// Listen for when delivery-checkout initializes and update button reference if needed
document.addEventListener('DOMContentLoaded', () => {
  // Wait a bit for delivery-checkout to initialize, then check if button was replaced
  setTimeout(() => {
    if (window.deliveryCheckout && window.deliveryCheckout.checkoutButton) {
      const currentButton = document.getElementById('checkout');
      if (currentButton && currentButton !== window.deliveryCheckout.checkoutButton) {
        console.log('Global.js - Updating delivery-checkout button reference after clone');
        window.deliveryCheckout.checkoutButton = currentButton;
      }
    }
  }, 500);
});
